module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_7042.8b22b92c.png";